import { useParams } from 'react-router-dom'
import { useEffect}  from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled, { keyframes } from 'styled-components';
import { getQuestions, setStatusFilter } from 'features/qaSessions/qaSessionSlice'
import QuestionItem from 'components/qaSessions/QuestionItem'
import SpinnerSmall from 'components/SpinnerSmall'

export default function QuestionsFeed() {

    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { questions, sortQuestionsBy, getQuestionsStatus, statusFilter, } =  useSelector((state) => state.qASession)  
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { sessionId } = useParams() 


    useEffect(() => { 
        dispatch(getQuestions({
            sessionId: sessionId,
            status: statusFilter,
            sortValue: sortQuestionsBy,
            churchId: profileChurch._id
        }))
    }, [  ])



    return (

        <QuestionsContainer>
            { (!user.isOrganization && !user.isAdmin) && (
                <UserQuestionsH2>Questions</UserQuestionsH2>
            )}
                {    
                    getQuestionsStatus === "LOADING" ? 
                    (
                        <SpinnerSmall border='#898989'/>
                    )
                    :  (getQuestionsStatus === "SUCCESS" && questions[`${statusFilter}_${sortQuestionsBy}`].data && questions[`${statusFilter}_${sortQuestionsBy}`].data.length > 0) ?
                    (
                        questions[`${statusFilter}_${sortQuestionsBy}`].data.map((question) => (
                            <QuestionItem 
                                key={question._id}
                                question={question}
                                />
                            )
                        )  
                    )
                    : (getQuestionsStatus === "SUCCESS" && questions[`${statusFilter}_${sortQuestionsBy}`].data.length ===  0) ?
                    (
                        <NoItems>  No {statusFilter} Questions </NoItems>
                    ) 
                    :
                    (
                        null
                    )
                }   
        </QuestionsContainer> 
    )
}

const NoItems = styled.div`
    color: var(--lightThemeFontColor);
    font-size: 14px;
    margin-top: 20px;
`

const UserQuestionsH2 = styled.div`
    width: 100%;
    font-size: 14px;
    color: #787878;
    text-align: left;

`
 

const QuestionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px; 
    padding-top: 20px;
    overflow-y: scroll;
`

// Keyframe animation for pulsing
const pulse = keyframes`
  0% {
    transform: scale(0.9);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(90, 153, 212, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
  }
`;


export const PulseContainer = styled.div`
  width: fit-content;
  height: 45px; 
  /* perspective: 100px; */
  backface-visibility: hidden;
  background: #fff;
  display: flex;
  flex-direction: row; 
  align-items: center;
  justify-content: center;
`;

export const PulseButton = styled.button`
  display: inline-block;
  padding: 8px 16px;
  font-size: 0.9em;
  outline: none;
  font-weight: 500;
  color: white;
  background: green;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(51, 108, 23, 0.5);
  animation: ${pulse} 1.5s infinite;

  &:hover {
    animation: none;
  }
`;
